import { z } from "zod";

/**
 * docs/architecture/authentication.md's password rule: minimum 8
 * characters, at least one uppercase, one lowercase, one number, one
 * special character. The one place this rule is written — both
 * `features/identity` (register) and `features/profile` (change password)
 * import it, so the policy can't drift between the two forms that enforce
 * it.
 */
export const passwordSchema = z
  .string()
  .min(8, "Password must be at least 8 characters")
  .regex(/[A-Z]/, "Password must include an uppercase letter")
  .regex(/[a-z]/, "Password must include a lowercase letter")
  .regex(/[0-9]/, "Password must include a number")
  .regex(/[^A-Za-z0-9]/, "Password must include a special character");
